import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-campaign-dashboard',
  templateUrl: './campaign-dashboard.component.html',
  styleUrls: ['./campaign-dashboard.component.scss']
})
export class CampaignDashboardComponent implements OnInit {
  objectKeys = Object.keys;
  campaignType = {
    // tslint:disable-next-line:max-line-length
    'College': ['Backend Software Developer', 'Software Developer', 'UI / UX Developer', 'HTML Developer', 'Backend Software Developer', 'Software Developer', 'UI / UX Developer', 'HTML Developer'],
    // tslint:disable-next-line:max-line-length
    'Facebook': ['Backend Software Developer', 'Software Developer', 'UI / UX Developer', 'HTML Developer', 'Backend Software Developer', 'Software Developer', 'UI / UX Developer', 'HTML Developer'],
    // tslint:disable-next-line:max-line-length
    'Training Institutes': ['Backend Software Developer', 'Software Developer', 'UI / UX Developer', 'HTML Developer', 'Backend Software Developer', 'Software Developer', 'UI / UX Developer', 'HTML Developer'],
    // tslint:disable-next-line:max-line-length
    'Walkin': ['Backend Software Developer', 'Software Developer', 'UI / UX Developer', 'HTML Developer', 'Backend Software Developer', 'Software Developer', 'UI / UX Developer', 'HTML Developer'],
  };

  locationArr = ['Mumbai', 'Delhi', 'Bangalore', 'Chennai', 'Kolkata', 'Pune'];

  constructor() { }

  ngOnInit() {
  }

  onClick() {
  }
}
